import {
  LayoutDashboard, Sparkles, Route, Calendar, Briefcase, Contact, Receipt, ClipboardList,
  LineChart, ChartLine, Mail, Users, Box, Building2, History, Gem, CalendarX, Logs, MailPlus,
  Database, CircleUser,
} from 'lucide-react';
import { NAV_GLYPH_DEFS as D } from './navGlyphDefs';

/** Entrance moves a glyph can play when its tab becomes selected. */
export const NAV_GLYPH_MOVES = ['draw', 'nod', 'flip', 'tilt', 'rise', 'squash', 'twinkle', 'wave', 'spinback', 'shake'];

const MAP = new Map([
  [LayoutDashboard, D.dashboard], [Sparkles, D.ai], [Route, D.route], [Calendar, D.schedule],
  [Briefcase, D.jobs], [Contact, D.customers], [Receipt, D.billing], [ClipboardList, D.estimates],
  [LineChart, D.reports], [ChartLine, D.reports], [Mail, D.emails], [Users, D.team], [Box, D.catalog],
  [Building2, D.company], [History, D.history], [Gem, D.plans], [CalendarX, D.cancellations],
  [Logs, D.audit], [MailPlus, D.invites], [Database, D.cleanup], [CircleUser, D.account],
]);

/** lucide component -> CrewVex glyph def, or null when unmapped. */
export function resolveNavGlyph(Icon) {
  return (Icon && MAP.get(Icon)) || null;
}
